document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Running script on Membership Create Account page.");

    function updateLoginLink() {
        let loginLink = document.querySelector("a[href*='/account/login']");
        
        if (!loginLink) {
            console.warn("⚠️ Login link not found! Watching for dynamic changes...");
            setTimeout(updateLoginLink, 1000); // Retry after 1 second if the link is dynamically loaded
            return;
        }

        console.log("🔗 Found login link:", loginLink.href);

        // Get URL parameters
        let urlParams = new URLSearchParams(window.location.search);
        let membership = urlParams.get("membership");

        if (membership) {
            let productUrl = `/products/${membership}`;

            // Fetch the default variant ID for the product (change this if needed)
            let variantId = {
                "founder-basic-membership": "48720439869717"
            }[membership] || ""; // Add more memberships if needed

            // Save the product redirect details in session storage
            sessionStorage.setItem("redirect_after_login", `${productUrl}${variantId ? `?variant=${variantId}` : ""}`);

            let returnUrl = encodeURIComponent("/account");
            let updatedUrl = `/account/login?return_to=${returnUrl}`;

            loginLink.href = updatedUrl;
            console.log("✅ Updated login link to:", loginLink.href);
        }
    }

    updateLoginLink();
});

document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Running script on Membership Create Account page.");

  const EMAIL_TAKEN_TEXT = "Email has already been taken";
  const LOGIN_URL = "/account/login";

  /* --------------------------------------------------
     Existing logic: update login link + preserve intent
  -------------------------------------------------- */
  function updateLoginLink() {
    let loginLink = document.querySelector("a[href*='/account/login']");

    if (!loginLink) {
      // Helium may inject later
      setTimeout(updateLoginLink, 1000);
      return;
    }

    // Get URL parameters
    let urlParams = new URLSearchParams(window.location.search);
    let membership = urlParams.get("membership");

    if (membership) {
      let productUrl = `/products/${membership}`;

      let variantId = {
        "founder-basic-membership": "48720439869717",
      }[membership] || "";

      sessionStorage.setItem(
        "redirect_after_login",
        `${productUrl}${variantId ? `?variant=${variantId}` : ""}`
      );

      let returnUrl = encodeURIComponent("/account");
      loginLink.href = `${LOGIN_URL}?return_to=${returnUrl}`;
    }
  }

  /* --------------------------------------------------
     NEW: Enhance Helium "email taken" error with login link
  -------------------------------------------------- */
  function enhanceEmailTakenError() {
    const errorEls = document.querySelectorAll(
      ".cf-field-errors, .cf-error-message, .cf-step-invalid"
    );

    errorEls.forEach((el) => {
      if (!el) return;

      const text = (el.textContent || "").trim();
      if (!text.includes(EMAIL_TAKEN_TEXT)) return;

      // Prevent re-processing if Helium re-renders
      if (el.dataset.loginEnhanced === "true") return;
      el.dataset.loginEnhanced = "true";

      const returnUrl = encodeURIComponent(
        window.location.pathname + window.location.search
      );

      el.innerHTML = `
        <strong>Email has already been taken.</strong>
        If this is your email,
        <a href="${LOGIN_URL}?return_url=${returnUrl}"
           style="text-decoration: underline; font-weight: 600;">
          click here to log in
        </a>.
      `;
    });
  }

  /* --------------------------------------------------
     Run once + observe for Helium DOM updates
  -------------------------------------------------- */
  updateLoginLink();
  enhanceEmailTakenError();

  const observer = new MutationObserver(() => {
    updateLoginLink();
    enhanceEmailTakenError();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
});